var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{attrs:{"icon":"arrow-right-circle","title":_vm.text || 'Go to page'}})
}
var staticRenderFns = []

export { render, staticRenderFns }